import {
  EmailSubscribe,
  PortalPrimaryFooter,
  PortalSecondaryFooter
} from "components/UI/organisms";

export const PortalFooter = () => {
  return (
    <footer id="portal-footer-container">
      <EmailSubscribe />
      <div className="portal-footer">
        <PortalPrimaryFooter data-testid="primary-footer" />
        <PortalSecondaryFooter data-testid="secondary-footer" />
      </div>
    </footer>
  );
};
